class FileGeometryLoader {
    load(key, path) {
        throw new Error("Method .load is not implemented");
    }

    unload(key) {
        throw new Error("Method .unload is not implemented");
    }
}

export default FileGeometryLoader;
